// shared/hooks/useInViewport.ts
import { useEffect, useRef, useState } from 'react';

export default function useInViewport<T extends HTMLElement>(opts?: IntersectionObserverInit) {
  const ref = useRef<T | null>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    if (!ref.current || typeof IntersectionObserver === 'undefined') return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            setInView(true);
            observer.disconnect();
          }
        });
      },
      { root: null, rootMargin: '200px', threshold: 0.01, ...opts }
    );

    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [opts]);

  return { ref, inView };
}
